import { render, staticRenderFns } from "./ElGridCollapseV2.vue?vue&type=template&id=25ff213c"
import script from "./ElGridCollapseV2.vue?vue&type=script&lang=js"
export * from "./ElGridCollapseV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports